import {
  Autocomplete,
  CircularProgress,
  ListItemButton,
  ListItemText,
  TextField,
} from "@mui/material";
import { RandomCode } from "hooks";
import React from "react";

const InputSearch = ({
  loading,
  value,
  handleInpChg,
  handleSelect,
  options,
  inputRef,
  ...other
}) => {
  return (
    <Autocomplete
      freeSolo
      value={null}
      loading={loading}
      inputValue={value}
      onInputChange={handleInpChg}
      onChange={handleSelect}
      options={options}
      getOptionLabel={(opt) => {
        if (typeof opt === "string" || opt.inputValue) return "";
        return `${opt.label}${
          opt.subtitle && opt.subtitle.trim() !== "" ? ` (${opt.subtitle})` : ""
        }`;
      }}
      isOptionEqualToValue={(opt, val) => opt.id === val.id}
      renderOption={(prop, opt, i) => (
        <ListItemButton
          {...prop}
          key={opt.id + i + RandomCode(5)}
          sx={{
            p: 0,
            mb: "2px",
            minHeight: "auto",
            "&:hover": {
              backgroundColor: "#f5f5f5",
            },
          }}
        >
          <ListItemText
            primaryTypographyProps={{ fontSize: "14px", color: "#333" }}
            secondaryTypographyProps={{ fontSize: "12px", color: "#777" }}
            sx={{ m: 0 }}
            primary={opt.label}
            secondary={opt.subtitle}
          />
        </ListItemButton>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          inputRef={inputRef}
          placeholder="Start typing or scanning"
          size="small"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress color="inherit" size={20} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      {...other}
    />
  );
};

export default InputSearch;
